<template>
  <Layout>
    <PageHeader :title="'Proje Listesi'" :items="breadcrumbArray"></PageHeader>
    <v-app>
      <div class="row">
        <div class="col-lg-12">
          <Results></Results>
        </div>
      </div>
    </v-app>

  </Layout>
</template>

<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import Results from "@/components/project/Results.vue"

export default {
  page: {
    title: "Proje Listesi",
    meta: [{ name: "description", content: "Proje Listesi" }],
  },
  components: {
    Layout,
    PageHeader,
    Results
  },
  data() {

    return {
      currentPage: 1,
      breadcrumbArray: [
        {
          text: "Proje Listesi",
          active: true,
        },
      ],

    };
  },
  methods: {

  },
};
</script>